import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { updateMyEmail } from '../mishtameretPortalApi';

export const portalFieldSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    bgcolor: theme.inputBg,
    color: theme.text,
    borderRadius: 2,
    fontFamily: theme.fontBody,
    '& fieldset': { borderColor: theme.borderSoft },
    '&:hover fieldset': { borderColor: theme.border },
    '&.Mui-focused fieldset': { borderColor: theme.accent },
  },
  '& .MuiInputLabel-root': { color: theme.textMuted, fontFamily: theme.fontBody },
  '& .MuiInputLabel-root.Mui-focused': { color: theme.accent },
});

export const portalButtonSx = (theme) => ({
  bgcolor: theme.accent,
  color: theme.accentContrast,
  fontFamily: theme.fontBody,
  fontWeight: 700,
  borderRadius: 2,
  minHeight: 44,
  px: 3,
  '&:hover': { bgcolor: theme.accentSoft },
  '&.Mui-disabled': { bgcolor: theme.borderSoft, color: theme.textMuted },
});

/** כתובת המייל של הנבחן, לקבלת הציון במייל. onSaved מקבל את החבר המעודכן */
const MemberEmailForm = ({ theme, member, onSaved }) => {
  const [email, setEmail] = useState(member.email || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => { setEmail(member.email || ''); }, [member.email]);

  const dirty = email.trim().toLowerCase() !== (member.email || '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    setSaved(false);
    try {
      const data = await updateMyEmail(email);
      onSaved?.(data.member);
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.error || 'שמירת הכתובת נכשלה. נסו שוב');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        <TextField
          size="small"
          type="email"
          label="כתובת מייל"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setSaved(false); }}
          inputProps={{ dir: 'ltr', autoComplete: 'email', inputMode: 'email' }}
          sx={{ ...portalFieldSx(theme), flex: '1 1 220px' }}
        />
        <Button type="submit" disabled={busy || !dirty} sx={portalButtonSx(theme)}>
          {busy ? <CircularProgress size={20} sx={{ color: 'inherit' }} /> : 'שמירה'}
        </Button>
      </Box>
      {error ? <Typography role="alert" sx={{ color: theme.danger, fontSize: '0.9rem', mt: 1 }}>{error}</Typography> : null}
      {saved ? (
        <Typography role="status" sx={{ color: theme.textMuted, fontSize: '0.9rem', mt: 1 }}>
          {member.email ? 'הכתובת נשמרה.' : 'הכתובת הוסרה.'}
        </Typography>
      ) : null}
    </Box>
  );
};

export default MemberEmailForm;
